export const usernameValidator = (username: any) => {
  if (!username) {
    return "Username is required";
  } 
  return "";
};

export const passwordValidator = (password: any) => {
  if (!password) {
    return "Password is required";
  } else if (password.length < 8) {
    return "Password must have a minimum 8 characters";
  }
  return "";
};

export const emailValidator = (email: any) => {
  if (!email) {
    return "Email is required";
  } 
  else if (!new RegExp(/\S+@\S+\.\S+/).test(email)) {
    return "Incorrect email format";
  }
  return "";
};

export const confirmPasswordValidator = (confirmPassword: any, form: any) => {
  if (!confirmPassword) {
    return "Confirm password is required";
  } else if (confirmPassword.length < 8) {
    return "Confirm password must have a minimum 8 characters";
  } else if (confirmPassword !== form.password) {
    return "Passwords do not match";
  }
  return "";
};